module.exports = __webpack_public_path__ + "img/vis-met-romige-citroensaus.0f10902a.jpeg";